import React from "react";

const VARIANTS = {
  primary:
    "border-blue-600 bg-blue-600 text-white hover:border-blue-700 hover:bg-blue-700 focus:ring-blue-500/30",

  indigo:
    "border-indigo-600 bg-indigo-600 text-white hover:border-indigo-700 hover:bg-indigo-700 focus:ring-indigo-500/30",

  warning:
    "border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100 focus:ring-amber-500/20 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300 dark:hover:bg-amber-500/20",

  neutral:
    "border-slate-300 bg-white text-slate-700 hover:bg-slate-50 focus:ring-slate-500/20 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800",
};

export default function ConvocationActionButton({
  icon,
  label,
  title,
  variant = "neutral",
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={`inline-flex min-h-10 w-full items-center justify-center gap-2 rounded-xl border px-3 py-2 text-xs font-semibold transition focus:outline-none focus:ring-4 sm:w-auto ${
        VARIANTS[variant] ?? VARIANTS.neutral
      }`}
    >
      <span aria-hidden="true">
        {icon}
      </span>

      <span>{label}</span>
    </button>
  );
}